import "./styles/App.css";
import MainContainer from "./pages/Container.jsx";

function App() {
  return <MainContainer />;
}

export default App;
